module.exports = __webpack_public_path__ + "static/media/cat3.9b8eec88.png";